export const AnswerFormats = {
    DATE: "DATE",
    DECIMAL: "DECIMAL",
    INTEGER: "INTEGER",
    MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
    OPTIONS: "OPTIONS",
    TIME: "TIME",
};
